// Tips: Don't import from index.ts here, build will fail
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TypeAheadDirective } from './directives/type-ahead.directive';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { RouterModule } from '@angular/router';
import { LocalSearchComponent } from './components/local-search/local-search.component';
import { GlobalSearchComponent } from './components/global-search/global-search.component';



@NgModule({
  declarations: [
    LocalSearchComponent,
    GlobalSearchComponent,
    TypeAheadDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AutoCompleteModule,
    InputTextModule,
    ButtonModule,
    CheckboxModule,
    VirtualScrollerModule
  ],
  exports: [
    LocalSearchComponent,
    GlobalSearchComponent,
    TypeAheadDirective
  ]
})
export class ADInputModule { }
